import type { FC, ReactNode } from 'react'

import OrielMark from '@/components/generals/oriel-mark'
import { NAV_LINKS } from '@/constants/landing'

const MORE_LINKS = [
    { label: 'Around people', href: '#with-people' },
    { label: 'A day at home', href: '#everyday' },
    { label: 'Reserve', href: '#reserve' }
]

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='border-t border-white/10 bg-[oklch(0.13_0.008_55)] text-ink-foreground'>
            <div className='mx-auto max-w-[1440px] px-5 pb-10 pt-16 md:px-8 md:pt-20'>
                <div className='grid gap-12 md:grid-cols-12'>
                    <div className='md:col-span-6'>
                        <a href='#hero' className='inline-flex items-center gap-2.5 rounded-full focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ember'>
                            <OrielMark className='size-8' />

                            <span className='font-heading text-3xl leading-none'>
                                Oriel
                            </span>
                        </a>

                        <p className='mt-6 max-w-sm font-heading text-2xl leading-snug text-ink-foreground/80'>
                            A second pair of hands, made to live quietly among people.
                        </p>
                    </div>

                    <nav aria-label='Footer' className='grid grid-cols-2 gap-8 md:col-span-6'>
                        <div>
                            <p className='font-mono text-[11px] uppercase tracking-[0.18em] text-ink-foreground/50'>
                                Oriel
                            </p>

                            <ul className='mt-5 flex flex-col gap-3'>
                                {NAV_LINKS.map(link => (
                                    <li key={link.href}>
                                        <a href={link.href} className='text-[15px] text-ink-foreground/75 transition-colors hover:text-ember'>
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div>
                            <p className='font-mono text-[11px] uppercase tracking-[0.18em] text-ink-foreground/50'>
                                Explore
                            </p>

                            <ul className='mt-5 flex flex-col gap-3'>
                                {MORE_LINKS.map(link => (
                                    <li key={link.href}>
                                        <a href={link.href} className='text-[15px] text-ink-foreground/75 transition-colors hover:text-ember'>
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </nav>
                </div>

                <div className='mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 text-sm text-ink-foreground/50 md:flex-row md:items-center md:justify-between'>
                    <p>
                        &copy; 2026 Oriel Robotics, Inc. All rights reserved.
                    </p>

                    <p className='max-w-xl md:text-right'>
                        Images show production-intent hardware. Specifications and availability may change before delivery.
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default SiteFooter
